import { Spinner } from "@nike/eds";

export const PageSpinner = () => (
  <div className="center-absolute">
    <Spinner data-testid="spinner" size='large' />
  </div>
);